import merge from 'deepmerge';
import { CustomTheme } from '.';
import jdsportsukTheme from "./index";


const theme: CustomTheme = {
    config: {
        displayName: "JD Wales Football Shop",
        showAddress1And2OnSameLine: true,
        faviconLogo: 'jdsportsuk/favicon.ico',
        headerLogo: '/Logo-Jdwfa-Navigation.png',
        headerLogoMobile: '/Logo-Jdwfa-Navigation-mobile.png',
        headerLogoSize: {height: '32px'},
    },
};

const jdwfaTheme: CustomTheme = merge(jdsportsukTheme, theme);

export default jdwfaTheme;